const $6008239529547428$var$STORAGE_KEY = "preferred-theme";
class $6008239529547428$export$2e2bcd8739ae039 {
    time;
    theme;
    body;
    storage;
    switcher;
    constructor(time, body, options = {}){
        this.time = time;
        this.body = body;
        this.storage = options.storage ?? this.defaultStorage();
        this.switcher = options.switcher;
        this.theme = this.defaultTheme();
        this.setTheme();
    }
    defaultTheme() {
        const savedTheme = this.savedTheme();
        if (savedTheme) return savedTheme;
        if (this.prefersDarkTheme()) return "night";
        const hour = this.time.getHours();
        if (hour > 6 && hour < 20) return "day";
        return "night";
    }
    toggleTheme() {
        this.theme = this.theme === "day" ? "night" : "day";
        this.saveTheme();
        this.setTheme();
        return this.theme;
    }
    setTheme() {
        this.body.classList.toggle("day", this.theme === "day");
        this.body.classList.toggle("night", this.theme === "night");
        if (this.switcher) {
            this.switcher.setAttribute("aria-pressed", String(this.theme === "night"));
            this.switcher.textContent = this.theme === "day" ? "switch to night theme" : "switch to day theme";
        }
    }
    defaultStorage() {
        try {
            return window.localStorage;
        } catch  {
            return undefined;
        }
    }
    savedTheme() {
        try {
            const savedTheme = this.storage?.getItem($6008239529547428$var$STORAGE_KEY);
            return savedTheme === "day" || savedTheme === "night" ? savedTheme : undefined;
        } catch  {
            return undefined;
        }
    }
    saveTheme() {
        try {
            this.storage?.setItem($6008239529547428$var$STORAGE_KEY, this.theme);
        } catch  {
        // Theme changes should still work when storage is unavailable.
        }
    }
    prefersDarkTheme() {
        return window.matchMedia?.("(prefers-color-scheme: dark)").matches ?? false;
    }
}


document.addEventListener("DOMContentLoaded", ()=>{
    const time = new Date();
    const page = document.body;
    const switcher = document.getElementById("theme-switcher");
    const themeSwitcher = switcher instanceof HTMLButtonElement ? switcher : undefined;
    const theme = new (0, $6008239529547428$export$2e2bcd8739ae039)(time, page, {
        switcher: themeSwitcher
    });
    themeSwitcher?.addEventListener("click", (event)=>{
        event.preventDefault();
        theme.toggleTheme();
    });
});


//# sourceMappingURL=willock.co.e8f17666.js.map
